module.exports = __webpack_public_path__ + "b91ee0fef325609aca9b0bf24cda3089.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/avatars/AvatarArabella5.png
// module id = 25
// module chunks = 0